<template>
  <Breadcrumb separator=">">
    <BreadcrumbItem
      v-for="f in items"
      :key="f.name"
      :to="{
        name: f.name,
        query: $route.meta.query ? $route.query : '',
        params: { reload: true }
      }"
    >{{ f.title }}</BreadcrumbItem>
  </Breadcrumb>
</template>

<script>
import router from '@router/router'
export default {
  name: 'breadcrumb-wrap',
  data () {
    return {
      items: []
    }
  },
  mounted () {
    this.buildItems()
  },
  methods: {
    buildItems () {
      const layout = router.find(f => f.name === 'layout')
      let name = this.$route.name
      while (name) {
        const temp = layout.children.find(f => f.name === name)
        const toName = name === this.$route.name ? '' : temp.name
        this.items.unshift({
          name: toName,
          title: temp.meta.title
        })
        name = temp.meta.parent
      }
    }
  }
}
</script>
